var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C6.4345 1 1.5 5.9345 1.5 12C1.5 18.0655 6.4345 23 12.5 23C18.5655 23 23.5 18.0655 23.5 12C23.5 5.9345 18.5655 1 12.5 1Z",
    fill: "#EB6E1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4523 12.0131V7.40275C13.4523 6.88798 13.0351 6.47083 12.5206 6.47083C12.0058 6.47083 11.5886 6.88798 11.5886 7.40275V12.3108C11.5886 12.3255 11.5922 12.3392 11.5929 12.3539C11.5807 12.6073 11.668 12.8646 11.8615 13.0581L15.3323 16.5286C15.6963 16.8926 16.2863 16.8926 16.6501 16.5286C17.0139 16.1646 17.0141 15.5746 16.6501 15.2108L13.4523 12.0131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/Inprogress.3b63eb510ff0f610269e4aa22e5722c7.svg";
export { ForwardRef as ReactComponent };